import { render, staticRenderFns } from "./StrawberryDiseaseAnalysis.vue?vue&type=template&id=c0b7c1e2&"
import script from "./StrawberryDiseaseAnalysis.vue?vue&type=script&lang=js&"
export * from "./StrawberryDiseaseAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports